import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AssignedClientsApiService } from 'features/assigned-clients/api/assign-clients-api.service';
import { queryClient } from 'providers';

import { AssignDetailClientsQueryKeys } from './query-keys';

const { DocumentsCountValue } = AssignedClientsApiService();

export const useDocumentsCount = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return DocumentsCountValue(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AssignDetailClientsQueryKeys.all,
        });
      },
    },
  );
};
